import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { ProgressSpinner } from 'primereact/progressspinner';
import {
  iniciaPilhaPendencias as iniciaPilhaPendenciasPedido,
  getConfiguracoes as getConfiguracoesPedido,
  PendenciasWizard,
  setPendencia,
} from './ValidacaoWizard';
import { dominioDemandaCirurgica } from '../../config/database';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

const headCells = [{ id: 'DEMANDA', numeric: false, disablePadding: true, label: 'Demandas' }];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align="left"
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === 'light'
      ? {
        color: theme.palette.secondary.main,
        backgroundColor: lighten(theme.palette.secondary.light, 0.85),
      }
      : {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.secondary.dark,
      },
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = () => {
  const classes = useToolbarStyles();

  return (
    <Toolbar>
      <Typography className={classes.title} variant="h6" id="tableTitle" component="div">
        Selecione a demanda
      </Typography>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
    height: '10vh',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

export default function SelecaoDemanda(props) {
  const classes = useStyles();
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(6);
  const [demandas, setDemandas] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [redirecionaPedido, setRedirecionaPedido] = React.useState(false);
  const { seq_paciente, closeModal } = props;

  useEffect(() => {
    setLoading(true);
    const profissional = JSON.parse(localStorage.getItem('profissional'));
    dominioDemandaCirurgica
      .get(`/api/listarDemandasPacienteEquipe/${seq_paciente}/${profissional.equipe_id}`)
      .then(
        response => {
          setDemandas(response.data);
          setLoading(false);
        },
        () => {
          setLoading(false);
        }
      );
  }, []);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const limparLocalStorage = () => {
    localStorage.setItem('activeStep', '0');
    localStorage.removeItem('convenio');
    localStorage.removeItem('peso');
    localStorage.removeItem('completed');
    localStorage.removeItem('paciente');
    localStorage.removeItem('dadosSolicitacao');
    localStorage.removeItem('faa');
    localStorage.removeItem('atendimento');
    localStorage.removeItem('data_atendimento');
    localStorage.removeItem('seq_atendimento');
    localStorage.removeItem('carater');
    localStorage.removeItem('dataSugerida');
    localStorage.removeItem('centroCirurgico');
    localStorage.removeItem('lateralidade');
    localStorage.removeItem('indicacaoClinica');
    localStorage.removeItem('prioridade');
    localStorage.removeItem('cidPrincipal');
    localStorage.removeItem('cidsSecundarios');
    localStorage.removeItem('tipoAcomodacao');
    localStorage.removeItem('diariasPrevistas');
    localStorage.removeItem('leitoUTI');
    localStorage.removeItem('tipoAnestesia');
    localStorage.removeItem('caixasOPME');
    localStorage.removeItem('materiaisConsumiveis');
    localStorage.removeItem('caixasCirurgicas');
    localStorage.removeItem('hemoderivados');
    localStorage.removeItem('procedimentoPrincipal');
    localStorage.removeItem('procedimentosSecundarios');
    localStorage.removeItem('documentos');
    localStorage.removeItem('pedidoCirurgia');
    localStorage.removeItem('equipamentos');
    localStorage.removeItem('equipeRequisitante');
    localStorage.removeItem('duracaoEstimada');
    localStorage.removeItem('pendenciasPaciente');
    localStorage.removeItem('pendenciasCirurgia');
    localStorage.removeItem('pendenciasSolicitacao');
    localStorage.removeItem('telefone');
    localStorage.removeItem('email');
    localStorage.removeItem('idPedidoCirurgia');
    localStorage.removeItem('celular');
    localStorage.removeItem('pendenciasSolicitacao');
    localStorage.removeItem('exames');
    localStorage.removeItem('dataInternacao');
    localStorage.removeItem('motivoAntecipacaoInternacao');
    localStorage.removeItem('avaliacaoAnestesica');
    localStorage.removeItem('motivoAvaliacaoAnestesica');
    localStorage.removeItem('internacao');
    localStorage.removeItem('modalidadeAtendimento');
    localStorage.removeItem('novoPaciente');
    localStorage.removeItem('tipoPedido');
    localStorage.removeItem('centroCirurgicoPermitido');
    localStorage.removeItem('caraterAtendimentoPermitido');
    localStorage.removeItem('lateralidadePermitida');
    localStorage.removeItem('cidPrincipalPermitido');
    localStorage.removeItem('cidSecundarioPermitido');
    localStorage.removeItem('tipoAcomodacaoPermitido');
    localStorage.removeItem('motivoAntecipacaoPermitido');
    localStorage.removeItem('tipoAnestesiaPadrao');
    localStorage.removeItem('procedimentoPrincipalPermitido');
    localStorage.removeItem('procedimentoSecundarioPermitido');
    localStorage.removeItem('caixaOPMEPermitida');
    localStorage.removeItem('materialConsumivelPermitido');
    localStorage.removeItem('caixaCirurgicaPermitida');
    localStorage.removeItem('hemocomponentePermitido');
    localStorage.removeItem('equipamentoPermitido');
    localStorage.removeItem('pedidoCirurgiaVemDoModelo');
    localStorage.removeItem('salaCirurgia');
    localStorage.removeItem('aprovacaoAutomatica');
    localStorage.removeItem('slaModelo');
    localStorage.removeItem('idModeloPedidoCirurgia');
    localStorage.removeItem('listaModalidadeAtendimento');
  };

  const pad = n => {
    return n < 10 ? `0${n}` : n;
  };

  const handleClick = async (event, id) => {
    // limparLocalStorage(); 
    iniciaPilhaPendenciasPedido();
    getConfiguracoesPedido();

    const profissional = JSON.parse(localStorage.getItem('profissional'));

    const dataDemanda = {
      idProfissional: profissional.profissional_id,
      idDemanda: id,
    };

    let pedidoCirurgia = {};

    const [
      responseCaixasOPME,
      responsecaixasMaterial,
      responseCaixasCirurgicas,
      responseHemoderivados,
      responseEquipamentos,
    ] = await Promise.all([
      dominioDemandaCirurgica.get(`/api/itemCaixaOPMEDemanda/${id}`),
      dominioDemandaCirurgica.get(`/api/itemMaterialConsumivelDemanda/${id}`),
      dominioDemandaCirurgica.get(`/api/itemCaixaCirurgicaDemanda/${id}`),
      dominioDemandaCirurgica.get(`/api/itemHemoderivadosDemanda/${id}`),
      dominioDemandaCirurgica.get(`/api/itemEquipamentoDemanda/${id}`),
    ]);

    dominioDemandaCirurgica
      .post('/api/incluirPedidoCirurgiaPorDemanda', dataDemanda)
      .then(
        response => {
          pedidoCirurgia = response.data;
        },
        err => {
          console.log(`ERRO AO INCLUIR COM DEMANDA: ${err.mensagemErro}`);
        }
      )
      .then(() => {
        const cidsSecundarios = pedidoCirurgia.cidSecundario;
        const procedimentosSecundarios = pedidoCirurgia.procedimentoSecundario;
        const {
          centroCirurgico,
          lateralidade,
          cidPrincipal,
          procedimentoPrincipal,
        } = pedidoCirurgia;
        const caixasOPME = [];
        const materialConsumivel = [];
        const caixasCirurgicas = [];
        const hemoderivados = [];
        const equipamentos = [];

        let lista = [];

        lista = responseCaixasOPME.data;
        lista.forEach(caixa =>
          caixasOPME.push({
            id: caixa.item.id,
            idLegado: caixa.item.idLegado,
            codigo: caixa.item.codigo,
            descricao: caixa.item.descricao,
            tipoItem: caixa.item.tipoItem,
            quantidade: caixa.quantidade,
            itemEventual: caixa.itemEventual,
            justificativaEventual: caixa.justificativaEventual,
          })
        );

        lista = responsecaixasMaterial.data;
        lista.forEach(material =>
          materialConsumivel.push({
            id: material.item.id,
            idLegado: material.item.idLegado,
            codigo: material.item.codigo,
            descricao: material.item.descricao,
            tipoItem: material.item.tipoItem,
            quantidade: material.quantidade,
            itemEventual: material.itemEventual,
            justificativaEventual: material.justificativaEventual,
          })
        );

        lista = responseCaixasCirurgicas.data;
        lista.forEach(caixa =>
          caixasCirurgicas.push({
            id: caixa.item.id,
            idLegado: caixa.item.idLegado,
            codigo: caixa.item.codigo,
            descricao: caixa.item.descricao,
            tipoItem: caixa.item.tipoItem,
            quantidade: caixa.quantidade,
          })
        );

        lista = responseHemoderivados.data;
        lista.forEach(hemoderivado =>
          hemoderivados.push({
            id: hemoderivado.item.id,
            idLegado: hemoderivado.item.idLegado,
            codigo: hemoderivado.item.codigo,
            descricao: hemoderivado.item.descricao,
            tipoItem: hemoderivado.item.tipoItem,
            quantidade: hemoderivado.quantidade,
            unidadeMedida: hemoderivado.unidadeMedida,
          })
        );

        lista = responseEquipamentos.data;
        lista.forEach(equipamento =>
          equipamentos.push({
            id: equipamento.item.id,
            idLegado: equipamento.item.idLegado,
            codigo: equipamento.item.codigo,
            descricao: equipamento.item.descricao,
            tipoItem: equipamento.item.tipoItem,
            quantidade: equipamento.quantidade,
          })
        );

        localStorage.setItem('cidsSecundarios', JSON.stringify(cidsSecundarios));
        localStorage.setItem(
          'procedimentosSecundarios',
          JSON.stringify(
            procedimentosSecundarios.map(item => {
              const { procedimento } = item;
              procedimento.quantidade = item.quantidade;
              return procedimento;
            })
          )
        );
        const cod_leito = pedidoCirurgia.codigoLeitoInternacao;
        pedidoCirurgia.paciente.COD_LEITO = cod_leito;
        localStorage.setItem('pedidoCirurgia', JSON.stringify(pedidoCirurgia));
        localStorage.setItem('centroCirurgico', JSON.stringify(centroCirurgico));
        localStorage.setItem('lateralidade', lateralidade ?? '');
        localStorage.setItem('indicacaoClinica', pedidoCirurgia.indicacaoClinica ?? '');
        if (cidPrincipal) localStorage.setItem('cidPrincipal', JSON.stringify(cidPrincipal));
        else localStorage.setItem('cidPrincipal', null);
        procedimentoPrincipal.quantidade = pedidoCirurgia.quantidadeProcedimentoPrincipal ?? null;
        localStorage.setItem('procedimentoPrincipal', JSON.stringify(procedimentoPrincipal));
        if (caixasOPME) localStorage.setItem('caixasOPME', JSON.stringify(caixasOPME));
        else localStorage.setItem('caixasOPME', []);
        if (materialConsumivel)
          localStorage.setItem('materiaisConsumiveis', JSON.stringify(materialConsumivel));
        else localStorage.setItem('materiaisConsumiveis', []);
        if (caixasCirurgicas)
          localStorage.setItem('caixasCirurgicas', JSON.stringify(caixasCirurgicas));
        else localStorage.setItem('caixasCirurgicas', []);
        if (hemoderivados) localStorage.setItem('hemoderivados', JSON.stringify(hemoderivados));
        else localStorage.setItem('hemoderivados', []);
        if (equipamentos) localStorage.setItem('equipamentos', JSON.stringify(equipamentos));
        else localStorage.setItem('equipamentos', []);
        localStorage.setItem('email', pedidoCirurgia.paciente.email ?? '');
        localStorage.setItem('telefone', pedidoCirurgia.paciente.telefone ?? null);
        localStorage.setItem('celular', pedidoCirurgia.paciente.celular ?? null);
        if (pedidoCirurgia.duracaoEstimada)
          localStorage.setItem('duracaoEstimada', pedidoCirurgia.duracaoEstimada);
        localStorage.setItem('prioridade', null);
        localStorage.setItem('tipoAcomodacao', null);

        const paciente = {
          SEQ_PACIENTE: pedidoCirurgia.paciente.idLegado,
          NRO_PRONTUARIO: pedidoCirurgia.paciente.NRO_PRONTUARIO,
          NOM_PESSOA: pedidoCirurgia.paciente.NOM_PESSOA,
          DAT_NASCIMENTO: pedidoCirurgia.paciente.DAT_NASCIMENTO,
          COD_SEXO: pedidoCirurgia.paciente.COD_SEXO,
          GMR: pedidoCirurgia.paciente.GMR,
        };

        const internacao = {
          DAT_HORA_INTERNACAO: pedidoCirurgia.internacao.dataInternacao,
          SEQ_INTERNACAO: pedidoCirurgia.internacao.idLegado,
          NRO_INTERNACAO: pedidoCirurgia.internacao.numeroInternacao,
        };

        const atendimento = {
          DAT_HORA_ATENDIMENTO: pedidoCirurgia.atendimento.dataAtendimento,
          NRO_FAA: pedidoCirurgia.atendimento.numeroFAA,
          SEQ_ATENDIMENTO: pedidoCirurgia.atendimento.idLegado,
        };

        localStorage.setItem('paciente', JSON.stringify(paciente));
        localStorage.setItem('atendimento', JSON.stringify(atendimento));
        if (pedidoCirurgia.atendimento) {
          setPendencia(0, PendenciasWizard.atendimentoInternacao, 'pendenciasPaciente');
        }
        if (pedidoCirurgia.dataHoraSugerida) {
          const dataSugerida = new Date(pedidoCirurgia.dataHoraSugerida);
          const localDateTime = `${dataSugerida.getFullYear()}-${pad(
            dataSugerida.getMonth() + 1
          )}-${pad(dataSugerida.getDate())}T${pad(dataSugerida.getHours())}:${pad(
            dataSugerida.getMinutes()
          )}`;
          localStorage.setItem('dataSugerida', localDateTime);
        } else localStorage.setItem('dataSugerida', pedidoCirurgia.dataHoraSugerida);
        localStorage.setItem('internacao', JSON.stringify(internacao));
        localStorage.setItem('dataInternacao', internacao.DAT_HORA_INTERNACAO);
        localStorage.setItem(
          'profissionalResponsavel',
          JSON.stringify(pedidoCirurgia.profissionalResponsavel)
        );
        localStorage.setItem('convenio', JSON.stringify(pedidoCirurgia.atendimento.convenioFull));
        localStorage.setItem('peso', pedidoCirurgia.atendimento.peso ?? null);
        localStorage.setItem('demandaId', id);
        setLoading(true);
        document.location.reload(true);
      });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const dataCirurgiaBodyTemplate = dataHoraSugerida => {
    return (
      <>
        {dataHoraSugerida === ' - '
          ? ' - '
          : new Date(dataHoraSugerida).toLocaleString([], {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          })}
      </>
    );
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const getDataFormatada = data => {
    if (data) return new Date(data).toLocaleString();
    return '';
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, demandas.length - page * rowsPerPage);

  if (loading) {
    return <ProgressSpinner style={{ left: '45%' }} />;
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar numSelected={selected.length} />
        <TableContainer style={{ maxHeight: '300px' }}>
          <Table className={classes.table} aria-labelledby="tableTitle" aria-label="enhanced table">
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length + 1}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={demandas.length}
            />
            <TableBody>
              {stableSort(demandas, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(row => {
                  return (
                    <TableRow
                      hover
                      onClick={event => handleClick(event, row.id)}
                      tabIndex={-1}
                      key={row.name}
                      style={{ cursor: 'pointer' }}
                    >
                      <TableCell align="left">
                        <div>
                          <span className="titulo-card-modal">
                            <strong>Procedimento Principal:</strong>
                          </span>
                          {row.procedimento}
                        </div>
                        <div>
                          <span className="titulo-card-modal">
                            <strong>Data de inserção:</strong>
                          </span>
                          {getDataFormatada(row.dataInclusao)}
                        </div>
                        <div>
                          <span className="titulo-card-modal">
                            <strong>Data da cirurgia:</strong>
                          </span>
                          {dataCirurgiaBodyTemplate(row.dataHoraSugerida)}
                        </div>
                        <div>
                          <span className="titulo-card-modal">
                            <strong>Nº demanda:</strong>
                          </span>
                          {row.codigo}
                        </div>
                        <div>
                          <span className="titulo-card-modal">
                            <strong>Especialidade:</strong>
                          </span>
                          {row.equipeRequisitante}
                        </div>
                      </TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[6]}
          component="div"
          count={demandas.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
